import { render } from "./HeroiconsSolidSpeakerphone.vue?vue&type=template&id=3b463106"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSpeakerphone.vue"]])

export default __exports__